(function() {
  'use strict';

  angular
    .module('mgpCorregedoriaApp.validacao')
    .constant('PARAMETRO', {
      LIMITE_FEITOS_VISTA_ABERTA: 73  //  Limite de dias para feitos com vista
                                      //  aberta (Relatórios da Corregedoria - Membros)
    });
})();
